export const PERSPECTIVES = [
  { key: 'personal_development', label: 'Personal Development', labelSv: 'Personlig utveckling', color: '#7A5FC0' },
  { key: 'together',             label: 'Together',             labelSv: 'Tillsammans',           color: '#C05F7A' },
  { key: 'value_creation',       label: 'Value Creation',       labelSv: 'Affärsvärde',           color: '#5F8AC0' },
  { key: 'freedom',              label: 'Freedom at Work',      labelSv: 'Frihet',                color: '#3a9a6a' },
]

export const emptyPerspective = () => ({ score: null, current_state: '', goal: '', activities: '', individual: [] })
